import axios from 'axios';

axios.defaults.baseURL = 'https://eagleeye92.pythonanywhere.com/api/';